{
  "UnifiedNavigation": "Navegue na Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Selecionar outra conta de organização",
  "help": "Ajuda",
  "ok": "OK",
  "profile": "Perfil",
  "searchButton": "Pesquisar",
  "sidenavMenuCloseTooltip": "Fechar o menu",
  "sidenavMenuLockTooltip": "Clique para bloquear o menu",
  "solutionSwitcher": "Alternar para outra solução",
  "themeCoachMark": "Tema claro",
  "themeCoachMarkMessage": "O cabeçalho da Experience Cloud agora oferece suporte a temas claros e escuros. Clique no seu avatar para alternar para seu tema preferido",
  "toggleSideNav": "Alternar menu de navegação lateral"
}
